module.exports = __webpack_public_path__ + "img/frs5.0ef8e406.jpg";